<div class="row rounded-card" id="settings-roles">
  <div class="flex flex-wrap justify-between items-end mb-4" id="setting-view-header-wr">
    <div class="flex flex-col">
      <h2 data-testid="roles-settings-title">{{ 'SYSTEM_SETTINGS.ROLES.ROLES_TITLE' | translate }}</h2>
      <span data-testid="roles-settings-subtitle" class="text-base">{{ 'SYSTEM_SETTINGS.COMPANY.SUBTITLE' | translate
      }}</span>
    </div>
    @if (!showCreateModal) {
      <div class="flex items-center gap-2">
        <button data-testid="create-default-roles-btn" class="btn outline-btn mr-2" [disabled]="data?.length > 0"
        (click)="openCreateDefaultRoles()">{{ 'SYSTEM_SETTINGS.ROLES.CREATE_DEFAULT_ROLES' | translate }}</button>
        <button data-testid="create-roles-btn" class="btn primary-btn" (click)="openCreateModal()">Add role</button>
      </div>
    }
    @if (showCreateModal) {
      <div class="flex items-center gap-2">
        <button data-testid="create-roles-btn" class="btn outline-btn" (click)="showCreateModal = false">{{ 'MODALBOXES.BTN_CANCEL' | translate }}</button>
      </div>
    }
  </div>
  <hr class="mb-3 mt-2 border-t">

  @if (showCreateModal == false) {
    <div class="view-content-wr">
      <div class="row">
        <div class="flex flex-col col-12 mb-2 text-wr">
          <!-- main content -->
          <p-table data-testid="table" [columns]="tableColumns" [value]="data" (onLazyLoad)="customSort($event)" [lazy]="true" [customSort]="true">
            <ng-template #header let-columns>
              <tr>
                @for (col of columns; track col; let colIndex = $index) {
                  <th [pSortableColumn]="col.field">
                    @if (colIndex !== columns.length-1) {
                      <div class="header-wr">
                        <span [attr.data-testid]="'table-header-' + colIndex" class="col-name">{{ ('TABLE.HEADER.' + col.header) | translate }}</span>
                        <p-sortIcon [field]="col.field"></p-sortIcon>
                      </div>
                    } @else {
                      <span [attr.data-testid]="'table-header-actions'" class="col-name">{{ col.field }}</span>
                    }
                  </th>
                }
              </tr>
              <tr>
                @for (col of columns; track col; let colIndex = $index) {
                  <th [attr.id]="col.field">
                    @if (colIndex !== columns.length-1;) {
                      <app-table-filter
                        [dataTestId]="'filter-' + col.field"
                        [filterType]="col.filter"
                        [placeHolder]="'TABLE.FILTER.' + col.header"
                        [filterData]="col.filterData"
                      (onFilter)="filterEvent(col.filterField ?? col.field, $event, col.operator)"></app-table-filter>
                    }
                  </th>
                }
              </tr>
            </ng-template>
            <ng-template #body let-rowData let-columns="columns" let-i="rowIndex">
              <tr>
                @for (col of columns; track col; let colIndex = $index) {
                  <td
                    [ngClass]="{'actions-col': colIndex === columns.length -1}">
                    @if (colIndex !== columns.length-1) {
                      <span class="p-column-title">{{ ('TABLE.HEADER.' + col.header) | translate }}:</span>
                      <span [attr.data-testid]="'cell-' + colIndex + '-' + i">{{ tableSettingService.getColumnValue(rowData, col) | defaultValue }}</span>
                    } @else {
                      <div class="flex justify-center">
                        @if (canManageSettings) {
                          <button type="button" pTooltip="{{ 'SYSTEM_SETTINGS.ROLES.EDIT_ROLE_DETAILS' | translate }}" tooltipPosition="top" class="btn-icon-only ui-btn-edit btn-icon icon-edit mr-2" (click)="goToDetails($event, rowData.id)" [attr.data-testid]="'btn-edit-' + i">
                            <span class="btn-label">{{ 'SYSTEM_SETTINGS.ROLES.EDIT_ROLE_DETAILS' | translate }}</span>
                          </button>
                        }
                        @if (canManageSettings) {
                          <button type="button" pTooltip="{{ 'SYSTEM_SETTINGS.ROLES.DELETE_ROLE' | translate }}" tooltipPosition="top" class="btn-icon-only ui-btn-delete btn-icon icon-delete mr-2" (click)="goToDelete($event, rowData)" [attr.data-testid]="'btn-delete-' + i">
                            <span class="btn-label">{{ 'SYSTEM_SETTINGS.ROLES.DELETE_ROLE' | translate }}</span>
                          </button>
                        }
                        @if (canManageSettings && rowData.isActive) {
                          <button type="button" pTooltip="{{ 'SYSTEM_SETTINGS.ROLES.DISABLE_ROLE' | translate }}" tooltipPosition="top" class="btn-icon-only ui-btn-delete btn-icon icon-deactivate-dg" (click)="onDisable($event, rowData)" [attr.data-testid]="'btn-disable-' + i">
                            <span class="btn-label">{{ 'SYSTEM_SETTINGS.ROLES.DISABLE_ROLE' | translate }}</span>
                          </button>
                        }
                        @if (canManageSettings && !rowData.isActive) {
                          <button type="button" pTooltip="{{ 'SYSTEM_SETTINGS.ROLES.ENABLE_ROLE' | translate }}" tooltipPosition="top" class="btn-icon-only ui-btn-delete btn-icon icon-activate-dg" (click)="onEnable($event, rowData)" [attr.data-testid]="'btn-enable-' + i">
                            <span class="btn-label">{{ 'SYSTEM_SETTINGS.ROLES.ENABLE_ROLE' | translate }}</span>
                          </button>
                        }
                      </div>
                    }
                  </td>
                }
              </tr>
            </ng-template>
            <ng-template #emptymessage>
              <tr>
                <td [attr.colspan]="tableColumns?.length ?? 0">{{ 'SYSTEM_SETTINGS.ROLES.NO_DATA' | translate }}</td>
              </tr>
            </ng-template>
          </p-table>
          <!-- Pagination -->
          <app-custom-paginator
            data-testid="paginator"
            [first]="paginatorFirst"
            [rows]="pageSize"
            [totalRecords]="page?.totalCount ?? 0"
            [rowsPerPageOptions]="[10, 20, 30]"
            [showCurrentPageReport]="true"
            [currentPageReportTemplate]="'PAGINATOR.CURRENT_PAGE_REPORT' | translate"
            [disabled]="(page?.totalCount ?? 0) === 0"
            [alwaysShow]="true"
            [showFirstLastIcon]="true"
            [showPageLinks]="true"
            [showPageSizeSelector]="true"
            (onPageChange)="onPaginatorChange($event)">
          </app-custom-paginator>
          <!-- /main content -->
        </div>
      </div>
    </div>
  }

  @if (showCreateModal) {
    <div>
      <section class="row">
        <div class="col-12">
          <h3 class="border-b pb-3">{{ 'SYSTEM_SETTINGS.ROLES.GENERAL_INFORMATION' | translate }}</h3>
        </div>
        <!-- General info -->
        <div class="field-wr col-12 col-sm-6 col-md-6 col-lg-4">
          <label data-testid="create-role-field-name" class="block text-sm" for="name">{{ 'SYSTEM_SETTINGS.ROLES.NAME' |
            translate }} <i class="icon-required-field"></i></label>
            <input data-testid="create-role-name-input" type="text" [(ngModel)]="currentRole.name" autocomplete="off">
          </div>
          <div class="field-wr col-12 col-sm-6 col-md-6 col-lg-4">
            <label data-testid="create-role-field-priority" class="block text-sm" for="priority">{{ 'SYSTEM_SETTINGS.ROLES.PRIORITY' | translate }} <i class="icon-required-field"></i></label>
            <input data-testid="create-role-priority-input" type="number" min="0" [(ngModel)]="currentRole.priority" autocomplete="off">
          </div>
          <div class="field-wr col-12 col-sm-6 col-md-6 col-lg-4">
            <label data-testid="create-role-field-landingpage" class="block text-sm">{{ 'SYSTEM_SETTINGS.ROLES.LANDINGPAGE' | translate }} <i class="icon-required-field"></i></label>
            <app-custom-dropdown
              [(ngModel)]="currentRole.landingPage"
              optionLabel="label"
              optionValue="value"
              [placeholder]="'SYSTEM_SETTINGS.ROLES.LANDINGPAGE' | translate"
              [isMultiselect]="false"
              [showSelectionChips]="true"
              [showClear]="false"
              [showSearchbox]="false"
              [searchMode]="'local'"
              [options]="landingPageOptions">
              <ng-template let-option>
                {{ option.label | translate }}
              </ng-template>
            </app-custom-dropdown>
          </div>
        </section>
        <section class="row">
          <div class="col-12">
            <accordion id="warranties-list" [expandIcon]="'icon-arrow-down'" [collapseIcon]="'icon-arrow-up'"
              [multiple]="true">
              @for (feature of features; track feature; let i = $index) {
                <accordion-tab [header]="feature.name">
                  @for (role of getRoles(feature); track role; let i = $index) {
                    <div class="row">
                      <div class="col-4">
                        {{ role.name }}
                      </div>
                      <div class="col-8">
                        <div class="m-1" style="text-align: right;">
                          <p-selectButton [options]="selectionOptions" optionLabel="label" optionValue="value" (onChange)="changeAction($event);"
                            [(ngModel)]="role.value">
                            <ng-template let-option pTemplate="item">
                              <span [attr.data-testid]="'btn-' + option.label">
                                {{ option.label }}
                              </span>
                            </ng-template>
                          </p-selectButton>
                        </div>
                      </div>
                    </div>
                  }
                </accordion-tab>
              }
            </accordion>
          </div>
        </section>
        <div class="row">
          <div class="col-12 mt-6 mb-4 pt-8 border-t">
            <div class="flex items-center justify-end gap-3">
              <button data-testid="update-role-settings-btn" class="btn primary-btn" (click)="save()">{{
              'SYSTEM_SETTINGS.ROLES.SAVE_CHANGES' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    }
  </div>


  <!-- Modalbox: delete -->
  <p-dialog [(visible)]="showDeleteModal" [header]="'SYSTEM_SETTINGS.ROLES.MODALBOX_TITLE_DELETE' | translate" [modal]="true" [blockScroll]="true" [draggable]="false" [resizable]="false">
    <section class="row">
      <div class="col-12">
        <h3 class="pb-3">{{ 'SYSTEM_SETTINGS.ROLES.MODALBOX_TITLE_DELETE_INFO' | translate }}</h3>
        <h4 class="border-b pb-3">{{ editRoleName }}</h4>
      </div>
    </section>
    <ng-template #footer>
      <button data-testid="delete-role-cancel-btn" class="btn outline-btn" (click)="onCancelDelete()">
        {{ 'SYSTEM_SETTINGS.ROLES.BTN_CANCEL' | translate }}
      </button>
      <button data-testid="delete-role-delete-btn" class="btn primary-btn" (click)="onDelete()">
        {{ 'SYSTEM_SETTINGS.ROLES.BTN_DELETE' | translate }}
      </button>
    </ng-template>
  </p-dialog>
